<template>
  <div>
    <template v-for="(item, idx) in ui.buttons">
      <img @click="clickButton(item)" v-if="item.type === 1 && item.content" :src="item.content" :key="'buttons' + idx" :style="getItemStyle(item)">
      <div @click="clickButton(item)" v-if="item.type === 2" :key="'buttons' + idx" :style="getItemStyle(item)">
        {{ item.content }}
      </div>
    </template>
    <template v-for="(item, idx) in ui.elements">
      <img v-if="item.type === 1 && item.content" :src="item.content" :key="'elements-' + idx" :style="getItemStyle(item)">
      <div v-if="item.type === 2" :key="'elements-' + idx" :style="getItemStyle(item)">
        {{ item.content }}
      </div>
    </template>
    <ui-popup ref="popup" :ui="ui"></ui-popup>
    <ui-popup ref="my-lucking" :ui="ui">
      <div class="p-20 pull-center" v-if="luckLoading">
        <van-loading class="m-t" size="24px">加载中...</van-loading>
      </div>
      <div class="xh-ya" v-else style="max-height: 65vh; margin-right: -10px; padding-right: 10px;">
        <Row :class="(idx !== 0 ? 'b-t-das': '')" v-for="(item, idx) in luckList" :key="idx">
          <Col class="p-10" :span="6">
            <img :src="productList['p' + item.product_id].image" class="w100" v-if="productList['p' + item.product_id]" />
            <img :src="lucking.location.thank_coming" class="w100" v-else />
          </Col>
          <Col class="p-10" :span="13">
            <div class="kk-title14 m-t" v-if="productList['p' + item.product_id]">
              {{ productList['p' + item.product_id].name }}
            </div>
            <div class="kk-title14 m-t" v-else>
              谢谢参与
            </div>
            <div class="m-t f12">
              {{ item.created_at }}
            </div>
          </Col>
          <Col class="p-10" :span="5" v-if="productList['p' + item.product_id]">
            <Button @click="seeLucking(item)" class="m-t-lg pull-right f12-all" size="small">查看</Button>
          </Col>
        </Row>
      </div>
    </ui-popup>

    <ui-share-guide ref="share-guide"></ui-share-guide>
    <lucking-win ref="lucking-win" :project-id="projectId" :lucking="lucking" :apiroot="apiroot" :member="member" :product-list="productList" :ui="ui"></lucking-win>
  </div>
</template>
<script>
import { getSimulatorBodyStyle, getPageSizeStyle, getItemStyle } from '@/libs/tool'
import UiPopup from './popup.vue'
import UiShareGuide from './shareGuide.vue'
import LuckingWin from '../lucking/win.vue'
import { Loading } from 'vant'

export default {
  name: 'UiElement',
  components: {
    UiPopup,
    UiShareGuide,
    LuckingWin,
    Loading
  },
  props: {
    projectId: {
      type: String
    },
    lucking: {
      type: Object
    },
    member: {
      type: Object
    },
    productList: {
      type: Object
    },
    apiroot: {
      type: String
    },
    ui: {}
  },
  data () {
    return {
      luckLoading: false,
      luckList: []
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    seeLucking (item) {
      this.$refs['lucking-win'].infoLucking(item.luck_code, item.product_id, item.receiving_obj)
    },
    getSimulatorBodyStyle (background) {
      return getSimulatorBodyStyle(background)
    },
    getPageSizeStyle (obj) {
      return getPageSizeStyle(obj)
    },
    getItemStyle (obj, idx) {
      return getItemStyle(obj)
    },
    getMyLucking () {
      this.luckLoading = true
      var postData = {}
      postData['sign'] = 'lucking'
      postData['action'] = 'myLucking'
      postData['project_id'] = this.projectId
      this.$http.post(this.apiroot + '/open/action', postData).then((response) => {
        this.luckLoading = false
        if (response.data.code === 1) {
          this.luckList = response.data.data
        } else {
          this.$Message.error('获取失败 请重试' + (response.data.message ? '，' + response.data.message + '。' : '。'))
        }
      })
    },
    clickButton (item) {
      switch (item.button_type) {
        case 'link':
          window.location.href = item.button_obj.content
          break
        case 'share_g':
          this.$refs['share-guide'].clickShareGuide(item.button_obj)
          break
        case 'open_box':
          this.$refs.popup.openMsg(item.button_obj.title, '<pre>' + item.button_obj.content + '</pre>')
          break
        case 'lucking_list':
          this.$refs['my-lucking'].open('我的奖品')
          this.getMyLucking()
          break
        default:
          console.log(item)
      }
    }
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ui/element.vue